import { useGetMembersQuery } from "../redux/features/members/membersApi";
import Member from "./Member";

export default function Members() {
  const { data: members, isLoading, isError, error } = useGetMembersQuery();

  let content = null;

  // is loading
  if (isLoading) {
    content = <div>Loading...</div>;
  }
  // is not loading and error
  else if (!isLoading && isError) {
    content = <div>{error}</div>;
  }

  // is not loading and no error and no members
  else if (!isLoading && !isError && members?.length === 0) {
    content = <div>No Member Found!</div>;
  }

  // is not loading and no error and have members
  else if (!isLoading && !isError && members?.length > 0) {
    content = members.map((member) => (
      <Member key={member.id} member={member} />
    ));
  }

  return (
    <div className="mt-8">
      <h3 className="text-xl font-bold">Team Members</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
}
